export default __webpack_public_path__ + "svg/CompaniesLogos/logo_bluco.svg?547f1236";